module.exports = __webpack_public_path__ + "img/cart.svg?v=1744197923362";